import Tracker from '../tracker'

export default {
  name: 'PixelTracker',

  props: {
    trackData: {
      type: Object,
      default() {
        return {
          evn: 'default_pixel_track'
        }
      }
    },

    fileName: {
      type: String
    }
  },

  computed: {
    sourceUrl() {
      return Tracker.pixel(this.trackData, this.fileName)
    }
  },

  render(h) {
    return h('img', {
      attrs: {
        src: this.sourceUrl,
        alt: this.fileName
      },
      style: { visibility: 'hidden' }
    })
  }
}
